import React from 'react';
import { declMod } from '@yandex-lego/i-bem-react';
export default declMod({
  glyph: 'type-indeterminate'
}, {
  block: 'icon',
  content: function content() {
    return React.createElement("svg", {
      width: "17",
      height: "17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fill: "#fff",
      d: "M4 7h9v3H4z"
    })); // eslint-disable-line
  }
});